import React from "react";
import {
  Box,
  Divider,
  Grid,
  Typography,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import GoogleIcon from "@mui/icons-material/Google";
import YouTubeIcon from "@mui/icons-material/YouTube";
import PinterestIcon from "@mui/icons-material/Pinterest";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Search, YouTube } from "@mui/icons-material";
import XIcon from "@mui/icons-material/Close";
import logo from '../../../../assets/logo.png'
import LocationOnIcon from '@mui/icons-material/LocationOn';

const QuickLinksData = [
  { id: '1', title: 'About Us', path: '/about' },
  { id: '3', title: 'Achievements', path: '/achievements' },
  { id: '3', title: 'Contact Us', path: '/contact' },
  { id: '4', title: 'Privacy Policy', path: '/privacy-policy' },
  { id: '5', title: 'Terms & Conditions', path: '/terms-and-conditions' },
]
const QuickLinksData1 = [
  { id: '1', title: 'Courses', path: '/courses' },
  // { id: '2', title: 'Blogs', path: '/blogs' },
  { id: '2', title: 'Gallery', path: '/gallary' },
  { id: '4', title: 'Facilities', path: '/facilities' },
  { id: '5', title: 'Summer Camp', path: '/summer' },
]

const Footer = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleNavigation = (to) => {
    navigate(to)
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box sx={{ position: "relative", overflow: "hidden" }}>
      <Box
        sx={{
          backgroundColor: "#1d67ab",
          color: "#fff",
          p: isSmallScreen ? 3 : 6,
        }}
      >
        <Grid
          container
          spacing={2}
          justifyContent={isSmallScreen ? "center" : "space-between"}
        >
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <Box>
              <img
                src={logo}
                alt="logo"
                width={isMobile ? 300 : 400}
                height="auto"
              />
            </Box>
            <Box>
              <Typography sx={{ color: "white", }}>
                Innovation is the cornerstone of our approach, fostering a culture of creativity and forward-thinking. Through cutting-edge teaching methods and curriculum design, we continuously strive to push boundaries and ignite curiosity, preparing our students for a rapidly evolving world.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={6} md={2} lg={2}>
            <Typography sx={{ fontSize: isMobile ? 18 : 20, fontWeight: "bold", color: "white" }}>QUICK LINKS</Typography>
            <Divider
              sx={{
                backgroundColor: "#fff",
                height: 0,
                width: "50%",
                margin: "5px 0",
              }}
            />
            {QuickLinksData1.map((name, index) => (
              <Box
                display="flex"
                alignItems="center"
                key={index}
                sx={{ mt: 1 }}
              >
                <ArrowRightIcon sx={{ fontSize: "16px", mr: 1 }} />
                <Box onClick={() => handleNavigation(name.path)} style={{ color: "#fff", textDecoration: "none", cursor: 'pointer' }}>
                  <Typography>{name.title}</Typography>
                </Box>
              </Box>
            ))}
          </Grid>

          {/* About Section */}
          <Grid item xs={6} sm={6} md={2} lg={2}>
            <Typography sx={{ fontSize: isMobile ? 18 : 20, fontWeight: "bold", color: "white" }}>ABOUT US</Typography>
            <Divider
              sx={{
                backgroundColor: "#fff",
                height: 0,
                width: "50%",
                margin: "5px 0",
              }}
            />
            {QuickLinksData.map((item, index) => (
              <Box
                display="flex"
                alignItems="center"
                key={index}
                sx={{ mt: 1 }}
              >
                <ArrowRightIcon sx={{ fontSize: "16px", mr: 1 }} />
                <Box onClick={() => handleNavigation(item.path)} style={{ color: "#fff", textDecoration: "none", cursor: 'pointer' }}>
                  <Typography>{item.title}</Typography>
                </Box>
              </Box>
            ))}
          </Grid>

          {/* Social Media */}
          <Grid item xs={12} sm={12} md={4} lg={4} >
            <Typography sx={{ fontSize: isMobile ? 18 : 20, fontWeight: "bold", color: "white" }}>CONTACT US</Typography>
            <Divider
              sx={{
                backgroundColor: "#fff",
                height: 0,
                width: "50%",
                margin: "5px 0",
              }}
            />
            <Box sx={{ display: "flex", gap: 2, alignItems: "center", position: "relative" }}>
              <LocalPhoneIcon sx={{ color: "white" }} />
              <Typography
                sx={{
                  py: isMobile ? 1 : 1,
                  cursor: "pointer",
                  color: "white",
                  fontSize: isMobile ? 16 : 16,
                  fontWeight: "bold",
                }}
                onClick={() => window.location.href = "tel:919844565757"}>
                +91 9844565757
              </Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center", position: "relative" }}>
              <MailOutlineIcon sx={{ color: "white" }} />
              <Typography
                sx={{
                  py: isMobile ? 1 : 1,
                  cursor: "pointer",
                  color: "white",
                  fontSize: isMobile ? 16 : 16,
                  fontWeight: "bold",
                }}
                onClick={() => window.location.href = "mailto:ppyelahanka@podarprep.com"}>
                ppyelahanka@podarprep.com
              </Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center", position: "relative" }}>
              <LocationOnIcon sx={{ color: "white" }} />
              <Typography
                sx={{
                  py: isMobile ? 1 : 1,
                  cursor: "pointer",
                  color: "white",
                  fontSize: isMobile ? 16 : 16,
                  fontWeight: "bold",
                }}>
                Next to KK Kids Hospital, Opp. to MEC School, Yelahanka New Town, Bangalore - 64
              </Typography>
            </Box>
            {/* <Box>
              <Typography sx={{ color: "#fff", fontWeight: "bold", fontSize: 20, pt: isMobile ? 1 : 1 }}>
                follow On
              </Typography>
              <Divider
                sx={{
                  backgroundColor: "#fff",
                  height: 0,
                  width: "40%",
                  margin: "5px 0",
                }}
              />
              <Grid
                sx={{
                  color: "#fff",
                  p: 1.5,
                  display: "flex",
                  justifyContent: "start",
                  gap: 2,
                }}
              >
                <FacebookRoundedIcon sx={{ fontSize: 28, backgroundColor: "#6f5fd6", borderRadius: "50%", p: 1, transition: "transform 0.5s ease", ":hover": { backgroundColor: "#fdce0d", transform: "scale(1.1);" } }} />
                <XIcon sx={{ fontSize: 28, backgroundColor: "#6f5fd6", borderRadius: "50%", p: 1, transition: "transform 0.5s ease", ":hover": { backgroundColor: "#fdce0d", transform: "scale(1.1);" } }} />
                <InstagramIcon sx={{ fontSize: 28, backgroundColor: "#6f5fd6", borderRadius: "50%", p: 1, transition: "transform 0.5s ease", ":hover": { backgroundColor: "#fdce0d", transform: "scale(1.1);" } }} />
                <LinkedInIcon sx={{ fontSize: 28, backgroundColor: "#6f5fd6", borderRadius: "50%", p: 1, transition: "transform 0.5s ease", ":hover": { backgroundColor: "#fdce0d", transform: "scale(1.1);" } }} />
                <YouTube sx={{ fontSize: 28, backgroundColor: "#6f5fd6", borderRadius: "50%", p: 1, transition: "transform 0.5s ease", ":hover": { backgroundColor: "#fdce0d", transform: "scale(1.1);" } }} />
              </Grid>
            </Box> */}
          </Grid>
        </Grid>
      </Box>

      {/* Bottom Bar */}
      <Box
        sx={{
          backgroundColor: "#fdce0d",
          p: 1,
          textAlign: "center",
          color: "black",
          fontWeight: "bold",
        }}
      >
        <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
          © 2026 podarjuniors.com All Rights Reserved | Developed by SN
          Info Systems.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
